import { ContractTemplate } from 'src/services/api';

export function sortContractTemplatesByCreatedDate(
  templates?: ContractTemplate[],
): ContractTemplate[] {
  if (!templates) return [];
  const copyOfTemplates = [...templates];
  copyOfTemplates.sort((a, b) => {
    const aDate = new Date(a.createdAt);
    const bDate = new Date(b.createdAt);
    return bDate.getTime() - aDate.getTime();
  });
  return copyOfTemplates;
}

export function isContractEntity(entity: string) {
  return /^CONTRACT:(\w+(?:-\w+)*):(\w+(?:-\w+)*)$/.test(entity);
}
